<!-- src/app/materials-grid/materials-grid.component.html -->
<div class="card m-3"> 
  <div class="card-body">

 
   <img src="./assets/kindpng_6109271.png" width="20%" style="float: right; vertical-align: top;">
   <h2>Materials</h2><br><br>
    <button mat-button color="success" 
[routerLink]="['/materials/add']" routerLinkActive="active">
<mat-icon class="mr">add</mat-icon>ADD</button>

<!-- CSV upload controls -->
<input type="file" accept=".csv" (change)="onFileSelected($event)" id="materialsCsv" style="margin-left:12px"/>
<button mat-button color="primary" (click)="uploadCsv()" [disabled]="!selectedFile">Upload CSV</button>

<!-- Sample CSV download -->
<button mat-button color="primary" (click)="downloadSampleCsv()" style="margin-left:8px;">
  <mat-icon class="mr">file_download</mat-icon>Download Sample CSV
</button>

<br>

<input type="text" (keyup)="applyFilter($event)" placeholder="Search" />

      <table class="table table-striped table-sm">
 
 
    <thead>
      <tr>
        <!-- <th>MaterialsID</th> -->
 
        <th><a (click)="sortBy('productName')">Product Name{{sortIcon('productName')}}</a></th>
        <th *ngIf="NotMobile"><a (click)="sortBy('productCategory')">Product Category{{sortIcon('productCategory')}}</a></th>
        <th *ngIf="NotMobile"><a (click)="sortBy('subCategory')">Sub Category{{sortIcon('subCategory')}}</a></th> 
        <th *ngIf="NotMobile"><a (click)="sortBy('productDescription')">Product Description{{sortIcon('productDescription')}}</a></th>
        <th *ngIf="NotMobile"><a (click)="sortBy('productPrice')">Product Price{{sortIcon('productPrice')}}</a></th>
        <th *ngIf="NotMobile"><a (click)="sortBy('productWeight')">Product Weight{{sortIcon('productWeight')}}</a></th>
        <th *ngIf="NotMobile"><a (click)="sortBy('units')">Units{{sortIcon('units')}}</a></th>
        <th *ngIf="NotMobile"><a (click)="sortBy('total')">Total{{sortIcon('total')}}</a></th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let material of filteredData">
        <!-- <td>{{ material.materialsID }}</td> -->
        <td  >{{ material.productName }}</td>
        <td *ngIf="NotMobile">{{ material.productCategory }}</td>
        <td *ngIf="NotMobile">{{ material.subCategory }}</td> 
        <td *ngIf="NotMobile">{{ material.productDescription }}</td>
        <td *ngIf="NotMobile">{{ material.productPrice }}</td>
        <td *ngIf="NotMobile">{{ material.productWeight }}</td>
        <td *ngIf="NotMobile">{{ material.units }}</td>
        <td *ngIf="NotMobile">{{ material.total }}</td>
        <td>
          <a mat-fab class="custom-fab" (click)="editMaterial(material)"><mat-icon>edit</mat-icon></a>
      
        </td>
      </tr>
    </tbody>
  </table>
  </div></div>
